import { useColumnsInstalacionesOT } from '@/erp/tecnico/ats/shared/hooks'
import { TABLE_CONSTANTS, useLoaders, useTableFilter, useTableServerSideFiltering } from '@/shared'
import { useFetchATSs, useUpdateATS } from '@/shared/actions/erp'
import { GeneralTable, TableTabsScene } from '@/shared/components/ui'
import { ATS } from '@/shared/interfaces'
import { ManageSearch } from '@mui/icons-material'
import { useUiConfirmModalStore } from '@/store/ui'

type Props = {
    customColumns?: any;
}

const TableSolicitudATSFisico = ({
    customColumns
}: Props) => {


  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  // const setAlert = useUiStore(s => s.setAlert)

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;



  ///* columns
  const {
    columnsPreRechazoTecnicoATS
  } = useColumnsInstalacionesOT();


  const {
    data: dataATS,
    isLoading,
    isRefetching,
  } = useFetchATSs({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      solicita_formato_fisico: true,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: false,
    },
  });


  const {
    mutate: updateATS,
    isPending: isLoadingUpdateATS,
  } = useUpdateATS({})
  useLoaders(isLoadingUpdateATS)

  return (
    <TableTabsScene
      globalFilter={globalFilter}
      onChangeFilter={onChangeFilter}
      searchInputText="por identificación"
      onChangeRangeDate={onChangeRangeDate}
      cleanFilter={cleanFilter}
    >
      <GeneralTable<ATS>
        columns={
          customColumns ||
          columnsPreRechazoTecnicoATS
        }
        data={dataATS?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={dataATS?.data?.count}
        // // actions ========
        enableColumnActions={true}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={true}
        onEdit={(ats: ATS)=>{
          setConfirmDialog({
            isOpen: true,
            title: "Aprobar ATS Físico",
            subtitle:
              "¿Está seguro que desea aprobar el ATS Físico?",
            onConfirm: () => {
              setConfirmDialogIsOpen(false);
              updateATS({
                id: ats.id_analisis_trabajo_seguro!,
                data: {
                  completado: true,
                  fecha_aprobacion: new Date(),
                  aprueba_formato_fisico: true,
                },
              });
            },
          });
        }}
        editIcon={<ManageSearch fontSize="large" />}
        toolTipTitleEditIcon={'Ver Detalles'}
        canDelete={false}
      />
    </TableTabsScene>
  )
}

export default TableSolicitudATSFisico